// @ts-check
/**
 * Typed client for Hermes templates.
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios';

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['HermesProgram']} HermesProgram */
/** @typedef {Schemas['HermesTemplateKindEnum']} HermesTemplateKind */

/**
 * A template that writes one care management document onto an engagement (HermesTemplate.Kind.ENGAGEMENT_SUMMARY).
 * @type {HermesTemplateKind}
 */
export const ENGAGEMENT_SUMMARY_KIND = 'engagement_summary';

/**
 * A per-patient template shown on the Team Review (IDT) board (HermesTemplate.Kind.TEAM_REVIEW).
 * @type {HermesTemplateKind}
 */
export const TEAM_REVIEW_KIND = 'team_review';

/**
 * A Care Management QA audit rubric: display.qa holds the questions managers answer (HermesTemplate.Kind.QA_RUBRIC).
 * @type {HermesTemplateKind}
 */
export const QA_RUBRIC_KIND = 'qa_rubric';

const BASE = '/api/hermes/templates';

/**
 * GET /api/hermes/templates/programs/ — the care management programs a document template can be limited to,
 * sorted by name.
 * @returns {Promise<HermesProgram[]>}
 */
export async function listPrograms() {
  const { data } = await axios.get(`${BASE}/programs/`);
  return data;
}

/** @typedef {Schemas['HermesTaskType']} HermesTaskType */

/**
 * GET /api/hermes/templates/task-types/ — the task types a QA rubric can audit (display.qa.task_type_ids): those in
 * the tenant's care management programs, each with the programs it's in.
 * @returns {Promise<HermesTaskType[]>}
 */
export async function listTaskTypes() {
  const { data } = await axios.get(`${BASE}/task-types/`);
  return data;
}

/** @typedef {Schemas['HermesEngagementType']} HermesEngagementType */

/**
 * GET /api/hermes/templates/engagement-types/ — the engagement types a document template can
 * be limited to.
 * @returns {Promise<HermesEngagementType[]>}
 */
export async function listEngagementTypes() {
  const { data } = await axios.get(`${BASE}/engagement-types/`);
  return data;
}

/** @typedef {Schemas['HermesTemplate']} HermesTemplate */

/**
 * GET /api/hermes/templates/ — every template on the tenant; documents are the ones whose kind is ENGAGEMENT_SUMMARY_KIND.
 * @returns {Promise<HermesTemplate[]>}
 */
export async function listTemplates() {
  const { data } = await axios.get(`${BASE}/`);
  return data;
}
